import color from "../../../../../constants/color";

const style = {
  card:{ backgroundColor: "#fff", 
    margin: 2,
    px:"20px",
    py:"20px",
    borderRadius: "20px",
    paddingBottom: "25px",
    "& .css-a5rdam-MuiGrid-root":{
      marginTop:"11px"
    },
   
  },
  countryCode: {
    ".react-tel-input": {
      width: "100%",
      "& .selected-flag": {
        "& .flag": {
          mt: "-9px",
        },
      }, 
    },
  },
  checkinBtn:
  { borderRadius: 50, 
    backgroundColor: "#28AA4A",
    color: "#fff", 
    ml: "8px" ,
    textTransform: "none", 
    fontSize: "12px",
  },
  modalInput: {
    display: "flex", 
    justifyContent: "center",
    my: "6px",
    height: "2.7em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "5.5px 14px",
    },
    borderRadius: "8px",
    "& .MuiOutlinedInput-root": {
      padding: "1.1px",
      borderRadius: "8px", 
      "& fieldset": {
        borderRadius: "8px",
      },
    },
    width: "100%"
  },

  dateInput:{
    width: "100%",
    my:1,
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
  },
  dropDownMenu:{
    fontSize:"14px",
    my:"10px",
    width: "100%",
  },
  heading:{
    fontSize:"20px",
    fontWeight:"600",
    pl:2
  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text,
  },
  cancelButtons: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: "#878787",
    fontSize: "14px",
    fontWeight: "500",
    ml: 3,
    px: 4,

  },

  inputSection: {
    display: {sx:"block", md: "flex"},
    justifyContent: "space-between",
    alignItems: "start",
    px: 2
  },
  inputSections: {
    display: {sx:"block", md: "flex"},
    alignItems: "start",
    gap:4.8,
    px: 2
  },
  inputBox: {
    width: {xs:"100%", md: "49%", lg:"31%"}
  },
  jobButtons: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: "#28AA4A", 
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator" :{
      position: "unset", 
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px", 
      marginLeft: "-8px", 
    },

  },
  mobile: {
    ".react-tel-input" :{ 
      ".selected-flag":{ 
        ".flag": {
          mt: "-9px",
        },
      },
    },
  
  }



};
export default style;